import { colors } from "../../theme/colors";
import type { ButtonSize, ButtonTheme } from "./types";
import { buttonSizes, buttonVariants } from "./types";

const { PRIMARY, SECONDARY, TERTIARY, TEXT_COLORED, TEXT_DARK } =
  buttonVariants;

export const component = "Button";

export const defaultButtonTheme: ButtonTheme = {
  [PRIMARY]: {
    background: (error) => (error ? colors.ERROR_50 : colors.BLACK),
    backgroundHover: (error) =>
      error ? colors.ERROR_50 : colors.GRAYSCALE_800,
    backgroundActive: (error) => (error ? colors.WHITE : colors.BLACK),
    backgroundDisabled: (error) =>
      error ? colors.WHITE : colors.GRAYSCALE_800,
    border: (error) => (error ? `1px solid ${colors.ERROR_300}` : "none"),
    borderShadowActive: (error) =>
      error
        ? "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #FEE4E2"
        : "none",
    borderActive: (error) => (error ? `1px solid ${colors.ERROR_300}` : "none"),
    borderHover: (error) => (error ? `1px solid ${colors.ERROR_300}` : "none"),
    borderDisabled: (error) =>
      error ? `1px solid ${colors.ERROR_200}` : "none",
    color: (error) => (error ? colors.ERROR_700 : colors.WHITE),
    disabledColor: (error) => (error ? colors.ERROR_300 : colors.GRAYSCALE_400),
  },
  [SECONDARY]: {
    background: (error) => (error ? colors.ERROR_50 : colors.WHITE),
    backgroundHover: (error) => (error ? colors.ERROR_50 : colors.BLACK),
    backgroundActive: (error) => (error ? colors.WHITE : colors.WHITE),
    backgroundDisabled: (error) => (error ? colors.WHITE : colors.GRAYSCALE_50),
    border: (error) =>
      error ? `1px solid ${colors.ERROR_300}` : `1px solid ${colors.BLACK}`,
    borderShadowActive: (error) =>
      error
        ? "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #FEE4E2"
        : "none",
    borderActive: (error) => (error ? `1px solid ${colors.ERROR_300}` : "none"),
    borderHover: (error) => (error ? `1px solid ${colors.ERROR_300}` : "none"),
    borderDisabled: (error) =>
      error ? `1px solid ${colors.ERROR_200}` : "none",
    color: (error) => (error ? colors.ERROR_700 : colors.BLACK),
    colorHover: (error) => (error ? colors.ERROR_700 : colors.WHITE),
    disabledColor: (error) => (error ? colors.ERROR_300 : colors.GRAYSCALE_400),
  },
  [TERTIARY]: {
    background: (error) => (error ? colors.ERROR_50 : colors.WHITE),
    backgroundHover: (error) => (error ? colors.ERROR_50 : colors.GRAYSCALE_50),
    backgroundActive: (error) => (error ? colors.WHITE : colors.WHITE),
    backgroundDisabled: (error) => (error ? colors.WHITE : colors.WHITE),
    border: (error) =>
      error
        ? `1px solid ${colors.ERROR_300}`
        : `1px solid ${colors.GRAYSCALE_300}`,
    borderShadowActive: (error) =>
      error
        ? "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #FEE4E2"
        : "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F2F4F7",
    borderActive: (error) =>
      error
        ? `1px solid ${colors.ERROR_300}`
        : `1px solid ${colors.GRAYSCALE_300}`,
    borderHover: (error) =>
      error
        ? `1px solid ${colors.ERROR_300}`
        : `1px solid ${colors.GRAYSCALE_300}`,
    borderDisabled: (error) =>
      error
        ? `1px solid ${colors.ERROR_200}`
        : `1px solid ${colors.GRAYSCALE_200}`,
    color: (error) => (error ? colors.ERROR_700 : colors.GRAYSCALE_700),
    disabledColor: (error) => (error ? colors.ERROR_300 : colors.GRAYSCALE_400),
  },
  [TEXT_COLORED]: {
    background: (error) => (error ? colors.WHITE : colors.WHITE),
    backgroundHover: (error) => (error ? colors.ERROR_50 : colors.SPECIAL_50),
    backgroundActive: (error) => (error ? colors.WHITE : colors.WHITE),
    backgroundDisabled: (error) => (error ? colors.WHITE : colors.WHITE),
    border: (error) => (error ? "none" : "none"),
    borderShadowActive: (error) => (error ? "none" : "none"),
    borderActive: (error) => (error ? "none" : "none"),
    borderHover: (error) => (error ? "none" : "none"),
    borderDisabled: (error) => (error ? "none" : "none"),
    color: (error) => (error ? colors.ERROR_700 : colors.SPECIAL_700),
    disabledColor: (error) => (error ? colors.ERROR_300 : colors.GRAYSCALE_300),
  },
  [TEXT_DARK]: {
    background: (error) => (error ? colors.WHITE : colors.WHITE),
    backgroundHover: (error) => (error ? colors.ERROR_50 : colors.GRAYSCALE_50),
    backgroundActive: (error) => (error ? colors.WHITE : colors.WHITE),
    backgroundDisabled: (error) => (error ? colors.WHITE : colors.WHITE),
    border: (error) => (error ? "none" : "none"),
    borderShadowActive: (error) => (error ? "none" : "none"),
    borderActive: (error) => (error ? "none" : "none"),
    borderHover: (error) => (error ? "none" : "none"),
    borderDisabled: (error) => (error ? "none" : "none"),
    color: (error) => (error ? colors.ERROR_700 : colors.GRAYSCALE_600),
    disabledColor: (error) => (error ? colors.ERROR_300 : colors.GRAYSCALE_300),
  },
};

const { XL, L, M, S, XS } = buttonSizes;

export const buttonSizesTheme: ButtonSize = {
  [XL]: {
    width: "156px",
    height: "60px",
    fontSize: "18px",
  },
  [L]: {
    width: "129px",
    height: "48px",
    fontSize: "16px",
  },
  [M]: {
    width: "125px",
    height: "44px",
    fontSize: "16px",
  },
  [S]: {
    width: "110px",
    height: "40px",
    fontSize: "14px",
  },
  [XS]: {
    width: "106px",
    height: "36px",
    fontSize: "14px",
  },
};

export const buttonIconSizesTheme = {
  [XL]: "36px",
  [L]: "40px",
  [M]: "44px",
  [S]: "48px",
  [XS]: "56px",
};
